
<template>
<v-container>
    <div class="ma-12">
        <v-data-table :headers="headers" :items="productos" sort-by="created_at" class="elevation-0 px-6 py-4">
            <!-- Header -->
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>Productos</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:[`item.valor`]="{ item }">
                {{item.valor.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
            </template>
            <template v-slot:[`item.sucursales`]="{ item }">
                <v-icon @click="update(item, 0)" v-if="disponible(item.sucursales)==1">mdi-check</v-icon>
                <v-icon @click="update(item, 1)" v-if="disponible(item.sucursales)==0">mdi-close</v-icon>
            </template>
            <!-- Acciones por fila -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
                    <v-list style="font-size:13px;">
                        <v-list-item @click="editItem(item)">
                            <v-icon small class="mr-2">
                                mdi-pencil
                            </v-icon>
                            Editar
                        </v-list-item>
                        <v-list-item @click="deleteItem(item)">
                            <v-icon small class="mr-2">
                                mdi-delete
                            </v-icon>
                            Eliminar
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <!-- Tabla sin información -->
            <template v-slot:no-data>
                No existen registros de productos aún
            </template>
            <!-- Monto -->
            <template v-slot:[`item.amount`]="{ item }">
                {{item.amount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
            </template>
        </v-data-table>

        <!-- Crear producto -->
        <v-dialog v-model="createDialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#f60e15" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <create @closeCreateDialogProducto="closeCreateDialogProducto"/>
        </v-dialog>
        <!-- Editar producto -->
        <v-dialog v-model="editDialog" max-width="700px">
          <edit v-bind:producto="producto" @closeDialogEditProducto="closeDialogEditProducto"/>
        </v-dialog>
        <!-- Dialogo confirmación de eliminación -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas borrar esta producto?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteProducto()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel()">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>


    </div>
</v-container>
</template>

<script>
import axios from "axios";
import Create from "../components/producto/create"
import Edit from "../components/producto/edit"
export default {
    components: {
        'create':Create,
        'edit':Edit,
    }, 
    props:{
      search:String
    },
    data () {
      return {
            producto:'',
            editDialog: false,
            createDialog: false,
            sheet: false,
            deleteId:''
      }
    },
    created(){
      this.$store.dispatch('producto/getProductos')
      this.$store.dispatch('currentUser/getUser')
    },
    methods:{
        update(producto, status){
            producto.sucursales[this.currentUser.sucursal-1].disponible = status
            axios.put("https://torstdio.site/api/v1/producto/actualizar",Object.assign(producto)).then(response=>{
                this.$store.dispatch('producto/getProductos')
            })
        },
        disponible(sucursales){
            return sucursales.filter(sucursal=>sucursal.sucursal == this.currentUser.sucursal).map(sucursal=>sucursal.disponible)[0]
        },
        closeDialogEditProducto: function(params) {
            this.editDialog = false;
            this.$store.dispatch('producto/getProductos')
        },
        closeCreateDialogProducto: function(params) {
            this.createDialog = false;
            this.$store.dispatch('producto/getProductos')
        },
        deleteProducto(){
            axios.delete("https://torstdio.site/api/v1/producto/borrar/"+this.deleteId).then(response => {
                this.deleteId = ''
                this.sheet = false
                this.$store.dispatch('producto/getProductos')
            });
        },
        cancel(){
            this.deleteId = ''
            this.sheet = false
        },
        deleteItem (item) {
            this.deleteId = item.id
            this.sheet = true
        },
        editItem(item){
            this.producto = this.$store.state.producto.productos.filter(producto=>producto.id == item.id)[0]
            this.editDialog = true
        },
    },
    computed:{
      headers(){ 
        return [
        { text: 'Nombre', value: 'nombre',},
        { text: 'Valor', value: 'valor' },
        { text: 'Disponible', value: 'sucursales',},
        { value: 'actions', sortable: false, align: 'end', },
      ]},
      currentUser:{
        get(){
          return this.$store.state.currentUser.user;
        }
      },
      productos:{
        get(){
          var productos = this.$store.state.producto.productos
          if(this.search!=''){
            productos = productos.filter(producto =>producto.nombre.toLowerCase().includes(this.search.toLowerCase()))
            return productos
          }else{
            return productos
          }
        }
      },
      products(){
        return this.$store.state.producto.productos
      },
    },
}
</script>

<style>

</style>

<style>
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #f7f7f7;
    }
</style>